
import { createMigration } from './utils';

const invisibleMedia1SceneDesignList = [
    'boldly:text_9',
    'boldly:text_11',
    'boldly:text_14b',
    'curly:text_listicleHeading2',
    'curly:outro_2',
    'curly:outro_3',
    'Geek:text_stat2',
    'Geek:outro_1',
    'classic_2:text_1b',
    'classic_2:text_1b2',
    'smart_main:text_listicle_heading_1',
    'regal_main:text_4',
    'regal_main:text_simple_statistic_1',
    'memory:outro_1',
    'memory:outro_2',
    'memory:outro_3',
    'dentons:text_media_test3',
    'tracer:title_1',
    'tracer:title_2',
    'tracer:text_1',
    'tracer:text_2',
    'tracer:text_3',
    'tracer:text_4',
    'tracer:text_5',
    'tracer:text_12',
    'tracer:text_13',
    'tracer:text_stat1',
    'tracer:text_stat2',
    'tracer:text_stat3',
    'tracer:title_listicleheading1',
    'tracer:text_list1',
    'tracer:text_list2',
    'tracer:outro_1',
    'tracer:outro_2',
    'tracer:outro_3',
    'ascend:text_13',
    'ascend:title_listicle_heading_1',
    'vivid:text_6',
    'vivid:text_12',
    'vivid:text_13',
    'circuit:outro_3',
    'brilliant:text_12',
    'brilliant:text_13',
    'brilliant:text_14',
    'emerson_marketing:title_2',
    'emerson_marketing:title_4',
    'emerson_marketing:text_Extra6',
    'emerson_marketing:title_2a',
    'emerson_spectrex:title_2',
    'emerson_spectrex:title_4',
    'emerson_spectrex:text_Extra6',
    'emerson:title_2',
    'emerson:title_4',
    'emerson:text_Extra6',
    'hitachi_vantara:text_A',
    'hitachi_vantara:text_B',
    'viasat:text_colorBG1',
    'viasat:text_colorBG2',
    'viasat:text_colorBG3',
    'viasat:text_colorBG4',
    'viasat:text_colorBG5',
    'viasat:text_colorBG6',
    'viasat:text_colorBG7',
    'viasat:text_2',
    'cbre_v2:title_intro2_v2',
    'cbre_v2:text_calltoaction',
    'cbre_v2:text_chaptermarker2_v2',
    'cbre_v2:text_Extra1',
    'cbre_v2:text_Extra2',
    'cbre_v2:text_Extra14',
    'cbre:title_intro2',
    'cbre:title_intro2_v2',
    'cbre:text_calltoaction',
    'cbre:text_chaptermarker2',
    'cbre:text_chaptermarker2_v2',
    'cbre:text_Extra1',
    'cbre:text_Extra2',
    'cbre:text_Extra14',
    'sarah_test:billow_title_2',
    'sarah_test:title_2',
    'sarah_test:billow_text_1',
    'paychex:text_stat1',
    'paychex:text_stat2',
    'colorado_technical_university:title_7',
    'GFXtest:title_1',
    'pattern_test:text_list2',
    'chevron_gradient:text_listicle_heading_1',
    'smart_2c:text_listicle_heading_1',
    'smart_2b:text_listicle_heading_1',
    'life_becomes_easier:title_6',
    'lunchandlearn:title_1',
    'lunchandlearn:outro_1',
];
const migrateAsset = (map, path) => {
    const asset = map.getIn(path);
    if (asset && asset.get('classType') === 'TimeAwareMediaAsset') {
        if (asset.get('name') === 'media_1' && asset.get('isEditable') === false) {
            map.deleteIn(path);
        }
    }
};

export const migrationTo9_151 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        if (!invisibleMedia1SceneDesignList.includes(scene.get('sceneDesign'))) {
            return scene;
        }
        return scene.withMutations(map => {
            map.get('children', []).forEach((child, c) => {
                const path = ['children', c];
                migrateAsset(map, path);
            });

            map.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((child, c) => {
                    const path = ['subslides', s, 'children', c];
                    migrateAsset(map, path);
                });
            });
        });
    },
});
